import React, { useEffect, useMemo, useState } from 'react';
import { BookOpen, PenTool, Sparkles, Wand2, Palette, Check } from 'lucide-react';
import { useT } from '../i18n';

const STAGE_DURATION = 7000;

export default function StoryLoader() {
  const t = useT();
  const STAGES = useMemo(() => [
    { icon: BookOpen, label: t.loading1 },
    { icon: PenTool,  label: t.loading2 },
    { icon: Sparkles, label: t.loading3 },
    { icon: Wand2,    label: t.loading4 },
    { icon: Palette,  label: t.loading5 },
  ], [t]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((x) => Math.min(x + 1, STAGES.length - 1));
    }, STAGE_DURATION);
    return () => clearInterval(id);
  }, []);

  const progress = Math.min(((active + 1) / STAGES.length) * 100, 95);

  return (
    <div className="story-loader-pro" role="status" aria-live="polite">
      <div className="story-loader-orb">
        <div className="story-loader-orb-glow" />
        <div className="story-loader-orb-ring" />
        <div className="story-loader-orb-ring story-loader-orb-ring-2" />
        <Sparkles size={40} className="story-loader-orb-icon" />
      </div>

      <h2 className="story-loader-title">{t.storyLoaderTitle}</h2>
      <p className="story-loader-subtitle">{t.storyLoaderSubtitle}</p>

      <ul className="story-loader-steps">
        {STAGES.map((stage, i) => {
          const Icon = stage.icon;
          const state = i < active ? 'done' : i === active ? 'active' : 'pending';
          return (
            <li key={i} className={`story-loader-step story-loader-step-${state}`}>
              <span className="story-loader-step-icon">
                {state === 'done' ? <Check size={18} /> : <Icon size={18} />}
              </span>
              <span className="story-loader-step-label">{stage.label}</span>
              {state === 'active' && <span className="story-loader-step-spinner" />}
            </li>
          );
        })}
      </ul>

      <div className="story-loader-progress">
        <div className="story-loader-progress-bar" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
